export const MARKETING_BASE_ON_RECEIVED_DATE = 'RECEIVED_DATE';
export const MARKETING_BASE_ON_AVAILABLE_DATE = 'AVAILABLE_DATE';
export const MARKETING_BASE_ON_DISPATCH_DATE = 'DISPATCH_DATE';

export const BASE_DATE_OPTIONS = {
  [MARKETING_BASE_ON_RECEIVED_DATE]: 'Received Date',
  [MARKETING_BASE_ON_AVAILABLE_DATE]: 'Available Date',
  [MARKETING_BASE_ON_DISPATCH_DATE]: 'Dispatch Date'
};

export const QUOTE_MARKETING_TYPE = 'QUOTE';
export const ORDER_MARKETING_TYPE = 'ORDER';

export const MARKETING_TYPES = {
  [QUOTE_MARKETING_TYPE]: 'Quote',
  [ORDER_MARKETING_TYPE]: 'Order'
};
